export default __webpack_public_path__ + "static/media/revenue-old.693c8485.png";